const _i18n_msg = {
  page_total : {
    EN: `all pages`,
    KO: `점검 대상 모든 페이지`,
    JP: `全ページ`
  },
  page : {
    EN: `Pages on the site`,
    KO: `점검 사이트의 페이지`,
    JP: `サイト内の各ページ`
  },
  ext : {
    EN: `External page`,
    KO: `외부 페이지`,
    JP: `外部ページ`
  },
  detect : {
    EN: `Detect page`,
    KO: `탐지 페이지`,
    JP: `検出ページ`
  },
  binary : {
    EN: `Binary page`,
    KO: `바이너리 페이지`,
    JP: `バイナリーページ`
  },
  resource : {
    EN: `Resource page`,
    KO: `리소스 페이지`,
    JP: `リソースページ`
  },
  error : {
    EN: `Error page`,
    KO: `에러 페이지`,
    JP: `エラーページ`
  },
  inspection : {
    EN: `inspection failed`,
    KO: `점검 실패`,
    JP: `検査不合格`
  },
}

//info
const _i18n_info = {
  copy : {
    EN: `Copied`,
    KO: `복사되었습니다`,
    JP: `コピー済み`
  },
  request_update : {
    EN: `request to update`,
    KO: `request to update`,
    JP: `更新要求`
  },
  ticket_copy : {
    EN: `ticket copied for QNA`,
    KO: `점검 번호가 복사되었습니다`,
    JP: `QNAのチケットコピー`
  },
  copy_failed : {
    EN: `Failed to ticket copy for QNA`,
    KO: `점검 번호 복사를 실패하였습니다.`,
    JP: `QNAのチケットコピーに失敗しました`
  },
  response_handler : {
    EN: `Complete Scanning`,
    KO: `Complete Scanning`,
    JP: `完全なスキャニング`
  },
  load_success : {
    EN: `loading successful`,
    KO: `loading successful`,
    JP: `読み込み成功`
  },
  load_done : {
    EN: `loading done`,
    KO: `loading done`,
    JP: `読み込み終了`
  }
}

//success
const _i18n_success = {
  //crud message
  saved: {
    EN: `saved`,
    KO: `저장되었습니다.`,
    JP: `セーブ済み`
  },
  updated: {
    EN: `updated`,
    KO: `업데이트되었습니다.`,
    JP: `アップデート済み`
  },
  removed: {
    EN: `removed`,
    KO: `삭제되었습니다.`,
    JP: `除去済み`
  },
  deleted: {
    EN: `deleted`,
    KO: `삭제되었어요.`,
    JP: `削除済み`
  },
  reload: {
    EN: `Saved! , reload 3sec later`,
    KO: `저장 성공!, 3초 후 페이지가 새로고침됩니다`,
    JP: `保存されました！ 3秒後に再読み込み`
  },
  load: {
    EN: `load Successful`,
    KO: `데이터 불러오기 성공`,
    JP: `読み込み成功`
  },
  service_cancel: {
    EN: `The service interruption received has been canceled.`,
    KO: `서비스가 다시 시작합니다.`,
    JP: `受信したサービス中断はキャンセルされました`
  },
  agent_apply : {
    EN: `Apply to agents.`,
    KO: `Apply to agents.`,
    JP: `エージョントに適用します`
  },
  refresh : {
    EN: `Refreshed`,
    KO: `Refreshed`,
    JP: `リフレッシュ`
  },
  expression_check : {
    EN: `Vaild expression: `,
    KO: `Vaild expression: `,
    JP: `有効な式: `
  },
  test : {
    EN: `request testing`,
    KO: `request testing`,
    JP: `要求試験`
  },
  done : {
    EN: `done`,
    KO: `done`,
    JP: `終了`
  },
}

//warning
const _i18n_warning = {
  otpToken: {
    EN: `Plz, Typing email.`,
    KO: `이메일을 입력하세요..`,
    JP: `メールを入力してください`
  },
  otpToken_2: {
    EN: `Typing was not email format`,
    KO: `이메일 형식에 맞춰 입력해주세요..`,
    JP: `入力した内容がメール形式とは異なります`
  },
  newPassword: {
    EN: `Please check password policy`,
    KO: `비밀번호 정책을 확인하세요.`,
    JP: `パスワードポリシーをご確認ください`
  },
  newPassword_2: {
    EN: `check password typing alphabet.`,
    KO: `비밀번호에 대소문자가 포함되는지 확인하세요.`,
    JP: `パスワードのアルファベット入力を確認してください`,
  },
  newPassword_3: {
    EN: `check password typing spacial.`,
    KO: `비밀번호에 특수문자가 포함되는지 확인하세요.`,
    JP: `パスワードのスペースを確認してください`,
  },
  newPassword_4: {
    EN: `check password typing number.`,
    KO: `비밀번호에 숫자가 포함되는지 확인하세요.`,
    JP: `パスワードの数字入力を確認してください`,
  },
  newPassword_5: {
    EN: `require group info.`,
    KO: `그룹정보를 확인하세요.`,
    JP: `グループ情報を要求します`,
  },
  newPassword_6: {
    EN: `password length more then `,
    KO: `비밀번호 길이가 더 길어야합니다. `,
    JP: `それ以上長いパスワードにしてください `,
  },

  data_check : {
    EN: `no have data`,
    KO: `no have data`,
    JP: `データがありません`
  },
  policy_check : {
    EN: `plz, select policy`,
    KO: `plz, select policy`,
    JP: `ポリシーを選択してください`
  },
  policy_check_2 : {
    EN: `plz, save your applied policy`,
    KO: `plz, save your applied policy`,
    JP: `適用したポリシーを保存してください`
  },
  domain_check : {
    EN: `Domain Type Check`,
    KO: `Domain Type Check`,
    JP: `ドメインタイプを確認してください`
  },
  whitePath_check : {
    EN: `This item already exists`,
    KO: `This item already exists`,
    JP: `この項目はすでに存在しています`
  },
  name_modify: {
    EN: `require new nickname`,
    KO: `require new nickname`,
    JP: `新しいニックネームが必要です`
  },

  agent_setting : {
    EN: `An agent from which to import settings`,
    KO: `An agent from which to import settings`,
    JP: `設定のインポート元となるエージョント`
  },
  multiplexing_setting : {
    EN: `Managed by multiplexing settings`,
    KO: `Managed by multiplexing settings`,
    JP: `多重化設定により管理`
  },
  notice : {
    EN: `notice`,
    KO: `notice`,
    JP: `通知`
  },
  warning : {
    EN: `warning`,
    KO: `warning`,
    JP: `警告`
  },
  require_startTime: {
    EN: `start Time is require`,
    KO: `start Time is require`,
    JP: `開始時間が必要です`
  },
  require_endTime: {
    EN: `end Time is require`,
    KO: `end Time is require`,
    JP: `終了時間が必要です`
  },
  remove_select : {
    EN: `first, remove white path or file setting`,
    KO: `first, remove white path or file setting`,
    JP: `まず、ホワイトパスまたはファイル設定を削除します`
  }
}

//error
const _i18n_error = {
  username: {
    EN: `Username required.`,
    KO: `아이디를 입력하세요.`,
    JP: `ユーザー名が必要です`
  },
  password: {
    EN: `Password required.`,
    KO: `비밀번호를 입력하세요.`,
    JP: `パスワードが必要です`
  },
  load_failed: {
    EN: `load failed`,
    KO: `로드 실패`,
    JP: `ロードに失敗しました`
  },
  failed: {
    EN: `failed`,
    KO: `failed`,
    JP: `失敗しました`
  },
  get : {
    EN: `load`,
    KO: `load`,
    JP: `ロード`
  },
  save_failed: {
    EN: `Save failed`,
    KO: `저장에 실패하였습니다.`,
    JP: `保存に失敗しました`
  },
  update_failed: {
    EN: `update failed`,
    KO: `저장에 실패하였습니다.`,
    JP: `アップデートに失敗しました`
  },
  remove_failed: {
    EN: `delete failed`,
    KO: `delete failed`,
    JP: `削除に失敗しました`
  },
  copy_failed: {
    EN: `copied failed`,
    KO: `copied failed`,
    JP: `コピーに失敗しました`
  },
  upload_failed : {
    EN: `upload failed`,
    KO: `upload failed`,
    JP: `アップロードに失敗しました`
  },
  start_failed : {
    EN: `start failed`,
    KO: `start failed`,
    JP: `開始に失敗しました`
  },
  policy_failed : {
    EN: `load failed policy`,
    KO: `load failed policy`,
    JP: `失敗したポリシーを読み込む`
  },
  agent_failed : {
    EN: `load failed agent`,
    KO: `load failed agent`,
    JP: `失敗したエージョントを読み込む`
  },
  parser_failed : {
    EN: `select one parser failed`,
    KO: `select one parser failed`,
    JP: `1 つのパーサーの選択に失敗しました`
  },
  agreement_failed : {
    EN: `apply agreement failed`,
    KO: `apply agreement failed`,
    JP: `契約の適用に失敗しました`
  },
  wmds_load: {
    EN: `WMDS load failed`,
    KO: `WMDS load failed`,
    JP: `WMDSのロードに失敗しました`
  },
  policy_load : {
    EN: `policy load failed`,
    KO: `policy load failed`,
    JP: `ポリシーのロードに失敗しました`
  },
  policy_json : {
    EN: `is not policy json format`,
    KO: `is not policy json format`,
    JP: `ポリシーはjson形式ではありません`
  },

  change_domain: {
    EN: `no have seleted domain`,
    KO: `no have seleted domain`,
    JP: `ドメインが選択されていません`
  },

  load_error : {
    EN: `load error #0`,
    KO: `load error #0`,
    JP: `ロードエラー #0`
  },
  load_error_1 : {
    EN: `load error #1`,
    KO: `load error #1`,
    JP: `ロードエラー #1`
  },
  load_error_2 : {
    EN: `load error #2`,
    KO: `load error #2`,
    JP: `ロードエラー #2`
  },
  load_error_3 : {
    EN: `load error #3`,
    KO: `load error #3`,
    JP: `ロードエラー #3`
  },
  load_error_4 : {
    EN: `load error #4`,
    KO: `load error #4`,
    JP: `ロードエラー #4`
  },
  load_error_5 : {
    EN: `load error #5`,
    KO: `load error #5`,
    JP: `ロードエラー #5`
  },
  load_error_6 : {
    EN: `load error #6`,
    KO: `load error #6`,
    JP: `ロードエラー #6`
  },
  load_error_7 : {
    EN: `load error #7`,
    KO: `load error #7`,
    JP: `ロードエラー #7`
  },

  error_code : {
    EN: `miss Connection Error Code : 1`,
    KO: `miss Connection Error Code : 1`,
    JP: `接続ミスエラー コード : 1`
  },
  error_code_2 : {
    EN: `miss Connection Error Code : 8`,
    KO: `miss Connection Error Code : 8`,
    JP: `接続ミスエラー コード : 8`
  },

  servername_check : {
    EN: `Invalid server name entered`,
    KO: `Invalid server name entered`,
    JP: `入力されたサーバー名が無効です`
  },
  license_check : {
    EN: `Number of domains exceeded! Please upgrade your license!`,
    KO: `Number of domains exceeded! Please upgrade your license!`,
    JP: `ドメイン数を超えました。ライセンスのアップグレードをお願いします`
  },
  crs_check : {
    EN: `Update Agent!, minimum version `,
    KO: `Update Agent!, minimum version `,
    JP: `エージョントアップデート：最小バージョン `
  },
  type_check : {
    EN: `type are required`,
    KO: `type are required`,
    JP: `タイプは必須です`
  },
  ext_check : {
    EN: `ext are required`,
    KO: `ext are required`,
    JP: `拡張子は必須です`
  },
  category_check : {
    EN: `category are required`,
    KO: `category are required`,
    JP: `カテゴリーは必須です`
  },
  code_check : {
    EN: `code are required`,
    KO: `code are required`,
    JP: `コードは必須です`
  },
  is_alive_check : {
    EN: `is_alive are required`,
    KO: `is_alive are required`,
    JP: `is_alive は必須です`
  },
  content : {
    EN: `Content is required`,
    KO: `Content is required`,
    JP: `内容は必須です`
  },

  duplicate: {
    EN: `duplicate`,
    KO: `duplicate`,
    JP: `複製`
  },
  verify : {
    EN: `can't verify license`,
    KO: `can't verify license`,
    JP: `ライセンスが確認できません`
  },
  regex_valid: {
    EN: `No vaild expression`,
    KO: `No vaild expression`,
    JP: `有効な式がありません`
  },
}

//alert
const _i18n_alert = {
  exist : {
    EN: `already exists`,
    KO: `already exists`,
    JP: `すでに存在しています`
  },
  remove_target : {
    EN: `no have remove target`,
    KO: `no have remove target`,
    JP: `ターゲットを削除しません`
  },
}

//임시 탐지 메세지 i18n
const temp_i18n = {
  EN : {
    'Country detected of user policy' : 'Country detected of user policy',
    'IPAddress detected of user policy' : 'IPAddress detected of user policy',
    'Host detected of user policy' : 'Host detected of user policy',
    'Path detected of user policy' : 'Path detected of user policy',
    'Parameter detected of user policy' : 'Parameter detected of user policy'
  },
  KO : {
    'Country detected of user policy' : `사용자 정책의 국가 IP 기반 탐지`,
    'IPAddress detected of user policy' : `사용자 정책의 IP 주소 탐지`,
    'Host detected of user policy' : `호스트가 사용자 정책 탐지`,
    'Path detected of user policy' : `사용자 정책의 경로 탐지`,
    'Parameter detected of user policy' : `사용자 정책의 매개 변수 탐지`,
  },
  JP : {
    'Country detected of user policy' : `ユーザーポリシーの国名が検出されました`,
    'IPAddress detected of user policy' : `ユーザーポリシーで検出されたIPアドレス`,
    'Host detected of user policy' : `ユーザーポリシーのホストが検出されました`,
    'Path detected of user policy' : `ユーザーポリシーのパスが検出されました`,
    'Parameter detected of user policy' : `ユーザーポリシーのパラメータを検出しました`,
  }
}

const i18n_data = {
  _i18n_msg,
  _i18n_info,
  _i18n_success,
  _i18n_warning,
  _i18n_error,
  _i18n_alert,
  temp_i18n
}

export default i18n_data